var _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V11.8571H15.2222V7.71429C15.2222 7.162 14.7745 6.71429 14.2222 6.71429H3.77778C3.22549 6.71429 2.77778 7.162 2.77778 7.71429V20.2857C2.77778 20.838 3.22549 21.2857 3.77778 21.2857H14.2222C14.7745 21.2857 15.2222 20.838 15.2222 20.2857V11.8571H17V22C17 22.5523 16.5523 23 16 23H2C1.44772 23 1 22.5523 1 22V6Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 9,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 9,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2C23 1.44772 22.5523 1 22 1H7.5C6.94772 1 6.5 1.44772 6.5 2V6L8.33333 5.792V3.76C8.33333 3.20772 8.78105 2.76 9.33333 2.76H20.1667C20.719 2.76 21.1667 3.20772 21.1667 3.76V17.6C21.1667 18.1523 20.719 18.6 20.1667 18.6H17.125C16.5727 18.6 16.125 18.1523 16.125 17.6V6.97366C16.125 6.43177 15.6934 5.98848 15.1517 5.97402L8.33333 5.792L6.5 6L14.7455 6.39578C15.2659 6.42076 15.6799 6.84105 15.697 7.36173L16.0932 19.3929C16.1109 19.9321 16.5531 20.36 17.0926 20.36H22C22.5523 20.36 23 19.9123 23 19.36V2Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.6a3c9079.svg";
export { ForwardRef as ReactComponent };